/** Whether a keydown should deselect the current canvas element. Escape is
 *  otherwise a text-editing convention (revert an in-progress edit, close a
 *  native picker), so it only means "deselect the canvas element" when focus
 *  isn't inside a form control. */
export function shouldDeselectOnKey(e: { key: string; target: EventTarget | null }): boolean {
  if (e.key !== 'Escape') return false;
  const target = e.target as HTMLElement | null;
  if (target && /^(INPUT|TEXTAREA|SELECT)$/.test(target.tagName)) return false;
  return true;
}
